import React, { useState, Suspense, lazy, memo, useEffect, useCallback, useRef } from 'react';
import { withTranslation } from 'react-i18next';
import { hot } from 'react-hot-loader/root';
import CircularProgress from '@material-ui/core/CircularProgress';
import {
  WbMarkdownHtml,
} from '../../../utils/common';
import UserServices from '../../../services/user.services';
import { menuListHelper } from '../../../utils/menuList';
import { navListHelper } from '../../../utils/navList';
import { eventKeyConstants } from '../../../utils/eventKey';
import i18next from 'i18next';

const userService = new UserServices();
const ImgIconComp = lazy(() => import(
  /* webpackChunkName: "imgcomp" */
  '../../../components/imgcomp'
));

const TopMenuProgressIndicator = () => {
  return (
    <div style={{paddingLeft: 18, marginBottom: 10}}><CircularProgress size={10} /></div>
  );
};

/*
 * Create a component for top menu
 */
const TopMenuApp = (props) => {
  const { actions, topMenuData } = props;
  const topMenuDataLen = Object.keys(topMenuData).length;
  const findActiveMenu = Object.entries(topMenuData)
    .filter(([key, value]) => typeof value === 'object' && value != null && value.isActive);
  const activeMenu = findActiveMenu.length ? findActiveMenu[0][0] : '';
  if (findActiveMenu.length) {
    document.title = findActiveMenu[0][1].pageTitle;
  }
  const _menus = [
    'rbr',
    'mywork',
    'board',
    'objectives',
    'meetings',
    'teams',
  ];

  const availableMenus = _menus.filter((item) => {
      return !!topMenuData[item]
  })

  const [fetchingTopMenuData, setFetchingTopMenuData] = useState(false);
  const [fetchedTopMenuData, setFetchedTopMenuData] = useState(false);

  const onShowMenuItem = useCallback(() => {
    if (fetchingTopMenuData || fetchedTopMenuData) return;
    setFetchingTopMenuData(true);
    userService.getTopMenuData({type: 'all'})
      .then((response) => {
        setFetchingTopMenuData(false);
        setFetchedTopMenuData(true);
        actions.loadTopMenuItems(response.data.data);
      });
  }, [fetchingTopMenuData, fetchedTopMenuData]);

  return (
    <Suspense fallback={null}>
      <div id="sidebar">
        {topMenuDataLen && (
          <div className="leftBarMenu sidebarMenu" role="menubar" id="app-main-menubar"
          onKeyDown = {(e)=>navListHelper(e,'app-main-menubar','.topMenuWrapper')}
          onMouseMove={()=>clearFocus()}
          >
            { availableMenus.map(
              (item,index) => typeof topMenuData[item] !== 'undefined'
                && topMenuData[item] && (
                  <TopMenuListComp
                    key={`topmenu_${item}`}
                    menuName={item}
                    menu={topMenuData[item]}
                    actions={actions}
                    index={index}
                    onShowMenuItem={onShowMenuItem}
                    fetchingTopMenuData={fetchingTopMenuData}
                  />
              ),
            )}
          </div>
        )}
      </div>
    </Suspense>
  );
}

const TopMenuListComp = (props) => {
  const { menu, menuName, actions,index, onShowMenuItem, fetchingTopMenuData } = props;
  const [showTopMenuPopUp, setTopMenu] = useState(true);
  const [popupMenu, showPopupMenu] = useState('');
  const [topMenuClickFlag, setTopmenuClick] = useState(true);
  const topNavigationMenu = useRef(null);

  const showMenuItem = (name) => {
    setTopMenu(!!name);
    showPopupMenu(name);
    if (name && typeof onShowMenuItem === 'function') onShowMenuItem(name);
  }

  useEffect(() => {
		document.addEventListener('click', handleClickOutside);
		document.addEventListener('mouseover', handleClickOutside);
		return () => {
			document.removeEventListener('click', handleClickOutside);
  		document.removeEventListener('mouseover', handleClickOutside);
		}
  }, []);

	const handleClickOutside = (e) => {
		if (!topNavigationMenu.current.contains(e.target)) {
			showMenuItem('');
		}
	}

  useEffect(()=> {
    if(!topMenuClickFlag){
      if(history.state && document.getElementById(history.state.menuId)) {
        let menuNameUpdated = document.getElementById(history.state.menuId).getAttribute('data-menuname');
        actions.updateActiveMenu(menuNameUpdated);
      }
    }
  },[topMenuClickFlag])

  window.onpopstate = function(e){
    setTopmenuClick(false);
    setTimeout(()=> {
      setTopmenuClick(true);
    },100)
  }

  const topMenuClick = (event, _menuName) => {
    if (event.ctrlKey || event.metaKey) {
      return false;
    }
    showMenuItem('');
    actions.updateActiveMenu(_menuName);
    if (typeof window.WsFullBoardComp !== 'undefined' && window.WsFullBoardComp) {
      window.WsFullBoardComp.unMountWsComponentAtNode();
    }
    if (typeof window.MeetingApp !== 'undefined' && window.MeetingApp) {
      window.MeetingApp.emptyDOM();
    }
    // active leftmenu
    if (typeof activeLeftMenuId === 'function') {
      activeLeftMenuId(_menuName);
    }
    userService.trackNavigation({ type: 'top', item: _menuName });
  }
 
  const topPopUpMenusKeyDown = (e, name) => {
    // A11y keyboard enablement
    switch (e.key) {
      case eventKeyConstants.ENTER:
       case eventKeyConstants.SPACE:
          e.preventDefault();
          const menuLink = document.getElementById(`menulink-${menu.id}`);
          if(menuLink != undefined || menuLink != null){menuLink.click();}
          break;
      case eventKeyConstants.ARROWDOWN:
        showMenuItem(name);
        e.preventDefault();
        setTimeout(() => {
          const fullmenu = document.getElementById(`submenu-${menuName}`); 
          const firstChild = fullmenu.querySelector('*[role="menuitem"]');
          if(firstChild != undefined || firstChild != null){firstChild.focus();}
        }, 0);
        break;
	    case eventKeyConstants.ARROWUP:
        e.preventDefault();
        break;
      case eventKeyConstants.ARROWLEFT:
      case eventKeyConstants.ARROWRIGHT:    
      case eventKeyConstants.ESCAPE:
        e.preventDefault();
        showMenuItem('');
        const navMenu = document.getElementById(`menu-btn-${menuName}`); 
        if(navMenu != undefined || navMenu != null){navMenu.focus();}
        break;
      default:
        showMenuItem('');
        break;
    }
  }
  return (
    <div
      className="topMenuWrapper"
      onMouseEnter={() => showMenuItem(menuName)}
      onMouseLeave={() => showMenuItem('')}
      onKeyDown={(e) => topPopUpMenusKeyDown(e, menuName)}
      aria-haspopup="true"
      aria-expanded={popupMenu == menuName ? 'true' : 'false'}
      role="menuitem"
      tabIndex={index == 0 ? "0" : "-1"}
      id={`menu-btn-${menuName}`}
      ref={topNavigationMenu}
    >
      <div
        id={`menu-${menu.id}`}
        className="leftMenuClick row "
        onClick={(e) => topMenuClick(e, menuName)}
        data-pop="true"
        data-url={menu.route}
        data-menuname={menuName}
        data-title={menu.pageTitle}
        data-testid={menu.navItemTestId}
        //aria-label={`Dropdown menu for top navigation ${menu.label}`}
      >
        <a id={`menulink-${menu.id}`} href={menu.route} className="top_menu_links" tabIndex="-1" data-testid={`top-nav-link-${menuName}`}>
          <div
            className={`column nav-item ${
              menu.isActive ? ' activeMainMenu ' : ''
            }`}
            style={{ minHeight: '19px', display: 'inline-block' }}
          >
            <div>
              <img
                width={menu.width}
                height={menu.height}
                className="column nav-img"
                src={menu.isActive ? menu.imgActive : menu.img}
                data-osrc={menu.img}
                data-hosrc={menu.imgActive}
                data-hsrc={menu.imgActive}
                alt=''
              />
            </div>
            <div
              className={
                menu.isActive ? ' top-nav-menu-title ' : ' nav-label-sel '
              }
            >
              {menu.label}
            </div>
          </div>
        </a>
      </div>
      {showTopMenuPopUp && popupMenu == menuName && (
        <TopPopUpMenuCompHOC
          key={`menu_${menu.id}`}
          menu={menu}
          menuName={menuName}
          menuLabel={menu.label}
          closeMenu={showMenuItem}
          fetchingTopMenuData={fetchingTopMenuData}
        />
      )}
    </div>
  );
}


const EmptyRecentItem = memo(() => (
  <div className="favouriteImage favouriteShow">
    <div className="displayIn">
      <Suspense fallback={null}>
        <ImgIconComp
          className="recentImg"
          id="recentImg"
          width="25"
          height="22"
        />
      </Suspense>
    </div>
    <div className="displayIn">
      {i18next.t('Your recent items will show here.')}
    </div>
  </div>
));

const EmptyFavoritesItem = memo(() => (
  <div className="favouriteImage favouriteShow">
    <div className="displayIn">
      <Suspense fallback={null}>
        <ImgIconComp
          className="favoriteImg"
          id="favoriteImg"
          width="25"
          height="22"
        />
      </Suspense>
    </div>
    <div className="displayIn favPlace">
      {i18next.t('Your favorites will show here')}
      {' '}
    </div>
  </div>
));

const FavoriteItem = memo(({ item, className, t,menuName,closeMenu } = props) => {
  let tabName = '';
  if (item.obj_type === 'myobjective' && item.obj_id == '0') {
    tabName = 'orggoals';
  }
  else if (item.obj_id == '2') {
    tabName = 'businpg';
  }
  return (
    <div
      className={`listOfResMenu truncateText ${className}`}
      data-type={item.obj_type}
      data-id={item.obj_type == 'personKeyResult' ? item.obj_encrypt_id : item.obj_id}
      data-tab-name={tabName}
      role="menuitem"
      tabIndex="-1"
      onKeyDown = {(e)=>menuListHelper(menuName,e,closeMenu)}
      onClick={() => userService.trackNavigation({ location: 'top', item: menuName, subItem: 'FavoriteItem' })}
    >
      <span> {item.name} </span>
      { (item.obj_type == 'user_goal'
          || item.obj_type == 'team_goal' )
        ? `'s ${t('objectives')}`
        : ''
      }
    </div>
  )
});

const RecentAIItem = memo(({ item, aiOpen,menuName,closeMenu } = props) => (
  <div
    className='listOfResMenu truncateText '
    data-id={item.id}
    onClick={(e) => aiOpen(e, item.id)}
    dangerouslySetInnerHTML={WbMarkdownHtml(
      validateAnchorTag(item.description),
    )}
    tabIndex="-1"
    role="menuitem"
    onKeyDown={(e) => {
      menuListHelper(menuName,e,closeMenu);
      if (e.key === eventKeyConstants.ENTER || e.key === eventKeyConstants.SPACE) {
        e.preventDefault();
        aiOpen(e, item.id)
      }
    }}
  />
));

const RecentItem = memo(({ item, className, t,menuName,closeMenu } = props) => (
  <div
    className={`listOfResMenu truncateText ${className}`}
    data-type={item.object_type}
    data-id={item.object_id}
    role="menuitem"
    tabIndex="-1"
    onKeyDown = {(e)=>menuListHelper(menuName,e,closeMenu)}
    onClick={() => userService.trackNavigation({ location: 'top', item: menuName, subItem: 'RecentItem' })}
  >
    <span dangerouslySetInnerHTML={WbMarkdownHtml((item.name), true)} />
    { item.object_type == 'user_goal'
        || item.object_type == 'team_goal'
      ? `'s ${t('objectives')}`
      : ''
    }
  </div>
))
const clearFocus = () => {
  document.body.classList.remove('is-tabbing');
  document.activeElement.blur();
}
const gotoNewMeeting = () => {
  document.location.search = ''
  document.location.pathname = '/wb/meeting/details/new'
}

const TopPopUpMenuComp = (props) => {
  const { menu, menuName, t, menuLabel,closeMenu, fetchingTopMenuData } = props;
  const { bottomMenuName } = menu;

  const openAiDetailPopupMenu = (e, id) => {
    e.preventDefault();
    e.stopPropagation();
    const aiId = id;
    const urlVal = `${wbConfig.baseUrl}/activity/aI?id=${aiId}`;
    setTimeout(() => openFullPopUp(aiFullViewPopUp, urlVal), 500);
  }

  let iconStyleName = 'fillAdd';
  if (menuName === 'meetings') {
    iconStyleName = 'meetingButtonImage';
  } else if (menuName === 'mywork') {
    iconStyleName = 'myworkButtonImage';
  }
	 
  const listOnName = menu.uniqClass;
  const favTabClass = menuName === 'mywork' ? menu.favTabClass : ' ';
  const bottomMenuClickEvent = menuName === 'mywork' ? 'add-ai' : menu.bottomMenuClickEvent;
  const bottomAddAi = menuName === 'mywork' ? menu.bottomMenuAiEvent : ' ';
  let recentItemsList =	menuName === 'mywork'
    ? menu.recentItems
    : removeFavFromRecentAct({
      recentList: menu.recentItems,
      favList: menu.favorites,
    });
  let showButton = true;

  if (menuName === 'meetings' && typeof menu.showMeetNow !== 'undefined') {
    showButton = !!menu.showMeetNow;
  }
  if (
    menuName === 'objectives'
    && typeof menu.showTeamObjective !== 'undefined'
  ) {
    showButton = !!menu.showTeamObjective;
  }
  if (menuName === 'mywork') {
    recentItemsList = recentItemsList.map((item) => {
      item.description = item.description.length
        ? item.description.replace(/</g, '&lt;').replace(/>/g, '&gt;')
        : item.description;
      return item;
    });
  } else {
    recentItemsList = (recentItemsList && recentItemsList.length) ? recentItemsList.map((item) => {
      item.name = item.name.length
        ? item.name.replace(/</g, '&lt;').replace(/>/g, '&gt;')
        : item.name;
      return item;
    }) : [];
  }
  return (
    <div
      className={`${menuName} topMenuPopup board-topMenuPopup newPopup menuLeft`}
      aria-label={`Dropdown menu for top navigation ${menuName} button`}
      role="menu"
      tabIndex="-1"
      id={`submenu-${menuName}`}
    >
      <div className="board-topMenuPopup-scroll verticalScroll"
     
      >
        {menu.isFavorites && (
        <div>
          <div className="bizfavorite" >{t('FAVORITES')}</div>
          <div role="group" aria-label="Favorites">
          {menu.favorites && menu.favorites.length > 0 ? (
            menu.favorites.map(
              (item, index) => item.name.length > 0 && (
                <FavoriteItem
                  key={`favorites_item_name_${index}`}
                  item={item}
                  className={` ${listOnName} ${favTabClass} `}
                  t={t}
                  menuName={menuName}
                  closeMenu={closeMenu}
                />
              ),
            )
          ) : (fetchingTopMenuData ? <TopMenuProgressIndicator /> : <EmptyFavoritesItem />)}
        </div>
        </div>
        )}
        <div className="commonBorder" role="seperator"/>
        <div className="allRecents">{t('RECENTS')}</div>
        <div className="recentNames" data-testid="recentNames" role="group" aria-label="Recents">
          {recentItemsList && recentItemsList.length > 0 ? (
                menuName == 'mywork' ? (
                  recentItemsList.map(
                    (item, index) => item.description.length > 0 && (
                        <RecentAIItem
                          key={`item_description_${item.id}`}
                          item={item}
                          aiOpen={openAiDetailPopupMenu}
                          menuName={menuName}
                          closeMenu={closeMenu}
                        />
                      ),
                  )
                ) : (
                  recentItemsList.map(
                    (item, index) => item.name.length > 0 && (
                        <RecentItem
                          key={`item_name_${index}`}
                          item={item}
                          className={` ${listOnName} `}
                          t={t}
                          menuName={menuName}
                          closeMenu={closeMenu}
                        />
                      ),
                  )
                )
          ) : (fetchingTopMenuData ? <TopMenuProgressIndicator /> : <EmptyRecentItem />)}
        </div>
      </div>
      <div className="commonBorder" role="seperator"/>
      {showButton ? (
        <div
          className={`addCommonButton add-top-section ${bottomMenuClickEvent}`}
          data-url={bottomAddAi}
          role="menuitem"
          tabIndex="-1"
          data-testid={menu.buttonTestId}
          onClick={() => { menu.isNewMeetingsEnabled && gotoNewMeeting() }}
          onKeyDown={(e)=>{
            if(menu.isNewMeetingsEnabled && (e.key==='Enter' || e.key===' ')) {
              gotoNewMeeting();
            }
            menuListHelper(menuName,e,closeMenu)}}
        >
          <div className="add-top-common" data-testid="add-top-common">
            <img
              width={menu.subImgWidth}
              height={menu.subImgHeight}
              className={iconStyleName}
              src={menu.boardImg}
              alt=''
            />
            <span className="verticalAlign" role="button">{bottomMenuName}</span>
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
}

const TopPopUpMenuCompHOC = withTranslation()(TopPopUpMenuComp);

// remove items from recent activity if it is already present in fav list.
const removeFavFromRecentAct = (props) => {
  if (
    props.favList
		&& props.favList.length > 0
		&& props.recentList
		&& props.recentList.length > 0
  ) {
    const recentListUpd = props.recentList.filter((it) => {
      const findItem = props.favList.find(
        (item) => item.obj_id === it.object_id.toString(),
      );
      if (findItem) {
        return false;
      }
      return true;
    });
    return recentListUpd;
  }
  return props.recentList;
};

export default hot(TopMenuApp);
